export default __webpack_public_path__ + "static/dropdown-menu.dark-41591cc15bdc660502379d7f4b4c3454f0b5a15d44a3f6458b0aba69ac59e687.png";